export enum AvailableLanguageKeys {
  en = 'en',
  es = 'es',
}

export type AppLanguages = {
  [key in AvailableLanguageKeys]: {
    name: string;
    translations: {
      // We omit 'en' key because 'name' attribute
      // must be used as default translation key
      [k in keyof Record<Exclude<AvailableLanguageKeys, 'en'>, string>]: string;
      //[k in keyof Omit<Record<AvailableLanguageKeys, string>, 'en'>]: string;
    };
  };
};

export const AVAILABLE_LANGUAGES: AppLanguages = {
  es: {
    name: 'Spanish',
    translations: {
      es: 'Español',
    },
  },
  en: {
    name: 'English',
    translations: {
      es: 'Inglés',
    },
  },
};

export const SELECTED_LANGUAGE_LS_KEY = 'selectedLanguage';
